import {
	enrollmentInit,
	getAccidentPlanInitData,
	getEnrollmentInitData,
	getVEBEnrollmentInitData
} from "./enrollmentInit";
import { getDependentPortalInitData, getMemberPortalInitData } from "./memberPortalInit";
import { getActiveVEBPlans } from "./VEBPlaniInit";

export const pages = {
	getMemberPortalInitData,
	getEnrollmentInitData,
	getVEBEnrollmentInitData,
	getDependentPortalInitData,
	getAccidentPlanInitData,
	getActiveVEBPlans
};
